import React from "react";

export const HomePadding = ({ children }) => {
  return (
    <div style={{ marginTop: "10px", marginBottom: "20px" }}>{children}</div>
  );
};
